import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ProblemSolution from "../components/ProblemSolution";
import UseCases from "../components/UseCases";
import HowItWorks from "../components/HowItWorks";
import WhyExecora from "../components/WhyExecora";
import Concierge from "../components/Concierge";
import ServiceArea from "../components/ServiceArea";
import SocialProof from "../components/SocialProof";
import AboutSection from "../components/AboutSection";
import Footer from "../components/Footer";
import StickyWhatsApp from "../components/StickyWhatsApp";
import EarlyMemberOfferPopup from "../components/EarlyMemberOfferPopup";

export default function Landing() {
  return (
    <div
      id="top"
      className="min-h-screen bg-white text-slate-900"
      data-testid="landing-page"
    >
      <Header />

      <main>
        <Hero />
        <ProblemSolution />
        <UseCases />
        <HowItWorks />

        {/* Uncomment when ready */}
        {/* <WhyExecora /> */}
        {/* <Concierge /> */}

        <ServiceArea />

        {/* Uncomment when ready */}
        {/* <SocialProof /> */}

        <AboutSection />
      </main>

      <Footer />
      <StickyWhatsApp />
      <EarlyMemberOfferPopup />
    </div>
  );
}
